// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"CustomEventPostbacks-primaryButton-3Fq_Nl","addEventButton":"CustomEventPostbacks-addEventButton-PLKSAQ","disabled":"CustomEventPostbacks-disabled-d5uWer"};